import React from 'react';
import PageLayout from '../../ui/layout/PageLayout';
import EditImageWorkspace from './components/EditImageWorkspace';
import useEditImageDomain from './hooks/useEditImageDomain';
import './styles.css';

function EditImagePage() {
  const state = useEditImageDomain();

  return (
    <PageLayout
      title="Editar Imagem"
      subtitle="Edição guiada por IA"
      primary={<EditImageWorkspace state={state} />}
      secondary={null}
    />
  );
}

export default EditImagePage;
